export default {
  '7OL': '7OL',
  '730': '730',
  'SUC': 'SUC',
  'ANF': 'ANF',
  'AUU': 'AUU',
};
